import React from 'react';
const Skeleton = () => {
  return (
    <>
    <div className="skeleton-container">
      <div className="skeleton-button"></div>
      <div className="skeleton-button"></div>
      <div className="skeleton-button"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    <div className="skeleton-container skelettestline">
        <div className="skeleton-button textsket"></div> 
        <div className="skeleton-button linesket"></div>
    </div>
    </>
  );
};
export default Skeleton;